import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './list-of-links.component.scss';
var ListOfLinks = /** @class */ (function (_super) {
    tslib_1.__extends(ListOfLinks, _super);
    function ListOfLinks(element) {
        return _super.call(this, element) || this;
    }
    ListOfLinks.prototype.init = function () { };
    ListOfLinks.prototype.bindEvents = function () { };
    return ListOfLinks;
}(Base));
export { ListOfLinks };



//////////////////
// WEBPACK FOOTER
// ./components/list-of-links/list-of-links.component.ts
// module id = 400
// module chunks = 0